import { useEffect, useState } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

/**
 * Whether the player has asked their device to reduce motion. Updates live if
 * they change the setting mid-game. CSS handles most of this on its own
 * (src/reducedMotion.scss); this is for motion driven from JavaScript, like
 * Bubble Pop's floating bubbles and the Celebrate effects.
 *
 * @returns {boolean}
 */
const useReducedMotion = () => {
  const [reduced, setReduced] = useState(
    () => typeof window !== "undefined" && window.matchMedia?.(QUERY).matches,
  );
  useEffect(() => {
    const media = window.matchMedia?.(QUERY);
    if (!media) return undefined;
    const onChange = () => setReduced(media.matches);
    media.addEventListener("change", onChange);
    return () => media.removeEventListener("change", onChange);
  }, []);
  return Boolean(reduced);
};

export default useReducedMotion;
